import { OrderDirection } from '@data';

export const OrderDirectionParam = {
  encode(value: any) {
    return value;
  },

  decode(strValue: any): OrderDirection | undefined {
    return strValue;
  },
};
